import React from 'react'
import PropTypes from 'prop-types'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'

import lockScreenPageStyle from 'assets/jss/material-dashboard-pro-react/views/lockScreenPageStyle.jsx'
import ResetPwdForm from 'views/Forms/ResetPwdForm.jsx';

class ResetPwdPage extends React.Component {
  render() {
    const { classes, match, history } = this.props

    return (
      <div className={classes.content}>
        <ResetPwdForm classes={classes} token={match.params.token} history={history}/>
      </div>
    );
  }
}

ResetPwdPage.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default withStyles(lockScreenPageStyle)(ResetPwdPage)



// WEBPACK FOOTER //
// ./src/views/Pages/ResetPwdPage.jsx